import { render, staticRenderFns } from "./create-job.component.html?vue&type=template&id=01472bc6&scoped=true&"
import script from "./create-job.component.ts?vue&type=script&lang=ts&"
export * from "./create-job.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-job.component.scss?vue&type=style&index=0&id=01472bc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01472bc6",
  null
  
)

export default component.exports